import { ViewContainerRef } from '@angular/core';

export class AccordionCtlTypeEmitterModel {
  accordionContent: ViewContainerRef; 
  accordionIndex: number;
  retainData: boolean;

  constructor(accordionContent: ViewContainerRef, accordionIndex: number, retainData: boolean){
    this.accordionContent = accordionContent;
    this.accordionIndex = accordionIndex;
    this.retainData = retainData;
  }
}
